export { ClipboardModule, ClipboardDirective, ClipboardService } from './src/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ngx-clipboard/dist/index.js
// module id = ../../../../ngx-clipboard/dist/index.js
// module chunks = 5